import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PeepingLogo } from "@/components/PeepingLogo";

const DOCS = {
  terms: {
    title: "Terms of Service",
    body: [
      "These Terms govern your use of PEEPING. By entering, you confirm you are at least 18 years of age.",
      "Payments currently operate in sandbox (test) mode. No real charges, subscriptions, or payouts are processed until a payment provider is approved and enabled.",
      "Permitted content is limited to swimwear, glamour, fashion, and non-explicit lifestyle material. No nudity or explicit sexual activity is permitted.",
      "You agree not to redistribute, scrape, or reproduce any content accessed through the platform.",
    ],
  },
  privacy: {
    title: "Privacy Policy",
    body: [
      "PEEPING stores the minimum information needed to operate your account: username, email, and a securely hashed password.",
      "Passwords are never stored in plain text. Sessions are managed with secure, httpOnly cookies.",
      "While payments operate in sandbox mode, no payment information is collected and no card data is processed.",
      "Private media is never cached by the installable app's service worker.",
    ],
  },
};

export default function Legal() {
  const { doc } = useParams();
  const content = DOCS[doc] || DOCS.terms;
  return (
    <div className="min-h-screen bg-[#080808] grain">
      <div className="mx-auto w-full max-w-md px-6 pb-16 pt-8">
        <Link to="/welcome" className="text-[#a7a0af] hover:text-white">
          <ArrowLeft size={22} />
        </Link>
        <div className="mt-8 flex flex-col items-center">
          <PeepingLogo className="w-36" showTagline={false} />
        </div>
        <h1 className="mt-10 text-2xl font-bold">{content.title}</h1>
        <div className="mt-5 flex flex-col gap-4">
          {content.body.map((p, i) => (
            <p key={i} className="text-sm leading-relaxed text-[#c7c1cf]">
              {p}
            </p>
          ))}
        </div>
      </div>
    </div>
  );
}
